import React from "react";
import { ArrowUp, ArrowDown, Trash2, Save } from "lucide-react";
import { TspCard, TspBadge } from "../../../components/primitives";
import TspPlacePicker from "../../../components/common/TspPlacePicker";
import TspRouteStopDetails from "../../../components/common/TspRouteStopDetails";
import { placeLabel } from "../../../utils/tspPlace";

const STATUS_TONE = { completed: "green", live: "amber", pending: "neutral" };
const STATUS_LABEL = { completed: "Visited", live: "In Progress", pending: "Not Visited" };

// The route as an editable list. Edits are local until Save Route; `canEdit` is
// false for a viewer or once the journey has ended (`lockedReason` says why).
export default function RouteSequenceCard({ stops, states, canEdit, lockedReason, dirty, saving, onMove, onRemove, onAdd, onSave }) {
  return (
    <TspCard
      title="Information about travelling"
      action={
        canEdit && (
          <button type="button" className="tsp-btn tsp-btn-success" onClick={onSave} disabled={saving || !dirty}>
            <Save size={14} /> {saving ? "Saving…" : "Save Route"}
          </button>
        )
      }
    >
      {lockedReason && <p className="tsp-muted-text">{lockedReason}</p>}

      <ol className="tsp-route-sequence">
        {stops.map((stop, index) => (
          <li key={stop.key} className="tsp-route-stop">
            <span className="tsp-route-stop-order">{index + 1}</span>
            <span className="tsp-route-stop-name">
              {placeLabel(stop)}
              <TspRouteStopDetails latitude={stop.latitude} longitude={stop.longitude} areas={stop.areas} />
            </span>
            <TspBadge tone={STATUS_TONE[stop.status]}>{STATUS_LABEL[stop.status]}</TspBadge>
            {canEdit && (
              <span className="tsp-route-stop-actions">
                <button type="button" className="tsp-icon-link-btn" onClick={() => onMove(index, -1)} disabled={saving || index === 0} aria-label={`Move ${stop.city} up`}>
                  <ArrowUp size={14} />
                </button>
                <button
                  type="button"
                  className="tsp-icon-link-btn"
                  onClick={() => onMove(index, 1)}
                  disabled={saving || index === stops.length - 1}
                  aria-label={`Move ${stop.city} down`}
                >
                  <ArrowDown size={14} />
                </button>
                <button
                  type="button"
                  className="tsp-icon-link-btn tsp-row-delete-btn"
                  onClick={() => onRemove(stop.key)}
                  disabled={saving || stop.hasVisits}
                  title={stop.hasVisits ? "This city has recorded visits and cannot be removed" : undefined}
                  aria-label={`Remove ${stop.city}`}
                >
                  <Trash2 size={14} />
                </button>
              </span>
            )}
          </li>
        ))}
        {stops.length === 0 && <li className="tsp-muted-text">No stops added yet.</li>}
      </ol>

      {canEdit && (
        <div className="tsp-add-entry-row">
          <span className="tsp-add-entry-label">Add State / District / City</span>
          <TspPlacePicker idPrefix="rp-add" states={states} onAdd={onAdd} addLabel="Add Stop" disabled={saving} />
        </div>
      )}
    </TspCard>
  );
}
